import DeleteIcon from 'assets/settings/components/DeleteIcon';
import EditIcon from 'assets/settings/components/EditIcon';

import {
  ActionButton,
  ActionsSection,
  Card,
  ContentSection,
  Description,
  ImageWrapper,
  Name,
  PlaceholderImage,
  StatusBadge,
} from './CompetitorCard.styles';

const CompetitorCard = ({ name, description, image, enabled, onEdit, onDelete }) => {
  const getImageUrl = () => {
    if (!image) return null;
    if (image.startsWith('http')) return image;
    return `${process.env.REACT_APP_SALES_API_URL}${image}`;
  };

  const imageUrl = getImageUrl();

  return (
    <Card>
      <ContentSection>
        <ImageWrapper>
          {imageUrl ? (
            <img src={imageUrl} alt={name} />
          ) : (
            <PlaceholderImage>{name?.charAt(0)?.toUpperCase() || 'C'}</PlaceholderImage>
          )}
        </ImageWrapper>
        <Name title={name}>{name}</Name>
        <StatusBadge $enabled={enabled}>{enabled ? 'Enabled' : 'Disabled'}</StatusBadge>
        <Description title={description || 'No description available'}>
          {description || 'No description available'}
        </Description>
      </ContentSection>
      <ActionsSection>
        <ActionButton onClick={onEdit}>
          <EditIcon size={16} color="#2D6CDF" />
          Edit
        </ActionButton>
        <ActionButton onClick={onDelete} $delete>
          <DeleteIcon size={16} color="#FB2C36" />
          Delete
        </ActionButton>
      </ActionsSection>
    </Card>
  );
};

export default CompetitorCard;
